// @flow
import React from "react";
import dayjs from "dayjs";
import cx from "classnames";
import SvgIcon from "root/components/SvgIcon";
import Checkbox from "root/components/Checkbox/Checkbox";
import {
	GCheckboxCol, GFileCol, GNameCol, GModifiedCol,
} from "..";
import SVG_ICONS from "~/assets/icons/icons";

type propsType = {
    item: Object,
    isSelected: boolean,
    rowClickHandler: Function,
};

const FileRow = (props: propsType) => {
	const renderFileIcon = () => (props.item.thumbnail
		? <img src={props.item.thumbnail} alt=""/>
		: <SvgIcon size="xl2" colorName="complete" path={SVG_ICONS.FILE}/>);

	return <div className={cx("FileRow", "flex items-center bb bc-source-bg pointer", { active: props.isSelected })}
		onClick={props.rowClickHandler}>
		<GCheckboxCol>
			<Checkbox checked={props.isSelected || false} />
		</GCheckboxCol>
		<GFileCol className="flex items-center">
			{renderFileIcon()}
		</GFileCol>
		<GNameCol>
			{props.item.name}
		</GNameCol>
		<GModifiedCol className="nowrap">{dayjs(props.item.client_modified).format("MMMM D, YYYY")}</GModifiedCol>
	</div>;
};

export default FileRow;
